export function initDetailControls(): void {
  const nav = document.querySelector<HTMLElement>('[data-main-nav]');
  const button = nav?.querySelector<HTMLButtonElement>('[data-search-toggle]');
  const input = nav?.querySelector<HTMLInputElement>('#search-input');
  if (!nav || !button || !input) return;
  const close = () => {
    delete nav.dataset.searchOpen;
    button.setAttribute('aria-expanded', 'false');
    button.setAttribute('aria-label', '検索を開く');
    button.focus();
  };
  button.addEventListener('click', () => {
    if (nav.hasAttribute('data-search-open')) {
      close();
      return;
    }
    nav.dataset.searchOpen = '';
    button.setAttribute('aria-expanded', 'true');
    button.setAttribute('aria-label', '検索を閉じる');
    input.focus();
  });
  input.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') close();
  });
}
